$(document).ready(function(){
  $(".product-form__submit").click(function(){
    var customproduct = $(".upsell_custom-product").attr("data-variant-id");
    var cartproduct = $(".horizontal-product").attr("data-variant-id");
    if(customproduct === cartproduct){
      $(".append_upsell_here").html("");
    } else {
      var upsell = $(".custom-upsell-product").html();
      $(".append_upsell_here").html(upsell);
    }
  });
});
